import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

import {
  FaMapMarkerAlt,
  FaDollarSign,
  FaTruck,
  FaToolbox,
  FaCar,
  FaCog,
  FaInfoCircle,
  FaArrowLeft,
  FaClipboardList,
  FaAddressCard,
} from "react-icons/fa";

export default function FranchiseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();


  const [franchise, setFranchise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showEnquiry, setShowEnquiry] = useState(false);

 useEffect(() => {
    if (!Number.isInteger(Number(id))) {
    setLoading(false);
    return;
  }

  async function loadListing() {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/cleaning/franchises/${id}`
      );

      if (!res.data || !res.data.listing) {
        console.error("Invalid franchise response:", res.data);
        setLoading(false);
        return;
      }

      setFranchise(res.data.listing);

    } catch (err) {
      console.error("Failed loading franchise details:", err);
    } finally {
      setLoading(false);
    }
  }

  loadListing();
}, [id, API_BASE_URL]);


  if (loading)
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loading...</p>;
  if (!franchise)
    return (
      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Franchise not found.
      </p>
    );

  const f = franchise;

  /* ------------------------------
      UI HELPERS (Copied from Business)
  ------------------------------- */
  const Section = ({ title, icon, children }) => (
    <section style={{ marginTop: "25px" }}>
      <h2
        style={{
          borderBottom: "2px solid #2e7d32",
          paddingBottom: "5px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#2e7d32",
          fontSize: "1.3rem",
        }}
      >
        {icon} {title}
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "15px",
          marginTop: "10px",
        }}
      >
        {children}
      </div>
    </section>
  );

  const Info = ({ icon, label, value }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#f9f9f9",
        borderRadius: "8px",
        padding: "10px 12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        gap: "12px",
      }}
    >
      <div style={{ fontSize: "1.3rem", color: "#2e7d32" }}>{icon}</div>
      <div>
        <div style={{ fontWeight: "600", color: "#333" }}>{label}</div>
        <div style={{ color: "#2e7d32" }}>{value}</div>
      </div>
    </div>
  );

  /* ------------------------------
      MAIN UI
  ------------------------------- */
  return (
    <div
      style={{
        maxWidth: "950px",
        margin: "2rem auto",
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      {/* HERO IMAGE */}
      <div style={{ position: "relative" }}>
        <img
          src={"/images/Cleaning.jpg"}
          alt="Franchise"
          style={{ width: "100%", height: "380px", objectFit: "cover" }}
        />

        <button
          onClick={() => navigate("/cleaning/franchises")}
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            background: "rgba(255,255,255,0.9)",
            border: "none",
            borderRadius: "50%",
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <FaArrowLeft />
        </button>
      </div>

      {/* CONTENT */}
      <div style={{ padding: "25px" }}>
        <h1 style={{ color: "#2e7d32", marginBottom: "5px" }}>
          {f.franchise_brand} — {f.territory_name}
        </h1>

        <p style={{ color: "#999", margin: "3px 0" }}>
          Franchise ID: FR-{f.id}
        </p>

        <p style={{ color: "#666", marginBottom: "10px" }}>
          <FaMapMarkerAlt style={{ color: "#2e7d32", marginRight: "5px" }} />
          {f.suburb}, {f.state} {f.postcode}
        </p>

        <h2 style={{ marginTop: "10px", color: "#2e7d32" }}>
          Price: ${Number(f.price).toLocaleString()}
        </h2>

        {/* -----------------------------
           OVERVIEW
        ------------------------------ */}
        <Section title="Franchise Overview" icon={<FaClipboardList />}>
          <Info
            icon={<FaAddressCard />}
            label="Franchise Type"
            value={f.franchise_type}
          />

          {f.franchise_type === "existing" && (
            <>
              <Info
                icon={<FaAddressCard />}
                label="Clients"
                value={f.number_of_clients || "N/A"}
              />

              <Info
                icon={<FaDollarSign />}
                label="Total Client Value"
                value={
                  f.total_client_value
                    ? `$${Number(f.total_client_value).toLocaleString()}`
                    : "N/A"
                }
              />

              <Info
                icon={<FaInfoCircle />}
                label="Avg Job Price"
                value={f.avg_job_price ? `$${f.avg_job_price}` : "N/A"}
              />
            </>
          )}

          {f.franchise_type === "new" && f.starter_clients_available == 1 && (
            <>
              <Info
                icon={<FaAddressCard />}
                label="Starter Clients"
                value={f.starter_clients_count || "N/A"}
              />

              <Info
                icon={<FaDollarSign />}
                label="Starter Total Value"
                value={
                  f.starter_clients_total_value
                    ? `$${Number(f.starter_clients_total_value).toLocaleString()}`
                    : "N/A"
                }
              />

              <Info
                icon={<FaInfoCircle />}
                label="Starter Avg Job Price"
                value={
                  f.starter_clients_avg_job_price
                    ? `$${f.starter_clients_avg_job_price}`
                    : "N/A"
                }
              />
            </>
          )}
        </Section>

        {/* -----------------------------
           WORK GUARANTEE
        ------------------------------ */}
        {f.work_guarantee == 1 && (
          <Section title="Work Guarantee" icon={<FaInfoCircle />}>
            <Info
              icon={<FaDollarSign />}
              label="Guarantee Amount"
              value={f.work_guarantee_amount || "Not specified"}
            />

            <Info
              icon={<FaInfoCircle />}
              label="Guarantee Period"
              value={f.work_guarantee_period || "Not specified"}
            />
          </Section>
        )}

        {/* -----------------------------
           INCLUDED ITEMS
        ------------------------------ */}
        <Section title="Included Items" icon={<FaToolbox />}>
          <Info
            icon={<FaCar />}
            label="Vehicle Included"
            value={f.vehicle_included ? "Yes" : "No"}
          />

          <Info
            icon={<FaTruck />}
            label="Trailer Included"
            value={f.trailer_included ? "Yes" : "No"}
          />

          <Info
            icon={<FaCog />}
            label="Equipment Included"
            value={f.equipment_included ? "Yes" : "No"}
          />

          {f.vehicle_details && (
            <Info
              icon={<FaCar />}
              label="Vehicle Details"
              value={f.vehicle_details}
            />
          )}

          {f.trailer_details && (
            <Info
              icon={<FaTruck />}
              label="Trailer Details"
              value={f.trailer_details}
            />
          )}

          {f.equipment_details && (
            <Info
              icon={<FaCog />}
              label="Equipment Details"
              value={f.equipment_details}
            />
          )}
        </Section>

        {/* -----------------------------
           DESCRIPTION
        ------------------------------ */}
        <Section title="Description" icon={<FaInfoCircle />}>
          <div style={{ gridColumn: "1 / span 2", color: "#444" }}>
            {f.description}
          </div>
        </Section>

        {/* -----------------------------
           CONTACT SELLER BUTTON
        ------------------------------ */}
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <button
           onClick={() => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.id === f.user_id) { 
    alert("You cannot enquire on your own franchise listing.");
    return;
  }
  setShowEnquiry(true);
}}

            style={{
              padding: "14px 22px",
              background: "#2e7d32",
              color: "#fff",
              border: "none",
              fontSize: "1.2rem",
              fontWeight: "bold",
              borderRadius: "8px",
              cursor: "pointer",
              width: "100%",
              maxWidth: "300px",
            }}
          >
            Contact Seller
          </button>
        </div>
      </div>

     {/* ENQUIRY POPUP */}
{showEnquiry && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "25px",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "500px",
      }}
    >
      <h2 style={{ marginTop: 0, color: "#2e7d32" }}>Contact Seller</h2>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          const token = localStorage.getItem("token");

          const payload = {
            listing_id: f.id,      // ✅ FIXED
           listing_type: "cleaning_franchise",

            message: e.target.message.value,
          };

          try {
            const res = await axios.post(
              `${API_BASE_URL}/api/contact-seller`,
              payload,
              { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.success) {
              alert("Your enquiry has been sent.");
              setShowEnquiry(false);
            } else {
              alert("Failed to send enquiry.");
            }
          } catch (err) {
            console.error("Enquiry Error:", err);
            alert("Server error sending enquiry.");
          }
        }}
      >
        <textarea
          name="message"
            maxLength={1000}
          placeholder="Write your message to the seller..."
          rows="4"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            marginBottom: "15px",
          }}
          required
        />

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#2e7d32",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Send Enquiry
        </button>

        <button
          type="button"
          onClick={() => setShowEnquiry(false)}
          style={{
            width: "100%",
            padding: "10px",
            marginTop: "10px",
            backgroundColor: "#ccc",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </form>
    </div>
  </div>
)}


    </div>
  );
}

/* BADGE COMPONENT */
function Badge({ text }) {
  return (
    <span
      style={{
        background: "#e6f3e8",
        padding: "5px 10px",
        borderRadius: "8px",
        color: "#2e7d32",
        fontSize: "0.8rem",
        fontWeight: "bold",
      }}
    >
      {text}
    </span>
  );
}
